import React from 'react';
import { CtaButton } from './CtaButton';
import { IMAGES, PRICING_ANCHOR, TRUST_LINE } from '../data/content';
export function FinalClose() {
  return <section className="relative overflow-hidden bg-ink py-10 sm:py-14" aria-labelledby="final-title" data-id="element-39" data-mp="s58biqd9mzd4">
      <div className="pointer-events-none absolute inset-0 opacity-[0.12]" style={{
      backgroundImage: `url(${IMAGES.coachKettlebell})`,
      backgroundSize: 'cover',
      backgroundPosition: 'center'
    }} aria-hidden="true" data-id="element-40" data-mp="i4zcz5vsx1uk" />
      <div className="relative mx-auto max-w-2xl px-4 text-center sm:px-6 lg:px-8" data-id="element-41" data-mp="1avq0cjuz9at7">
        <p className="inline-flex rounded-full border border-gold/40 bg-gold/[0.08] px-3 py-1 text-[9.5px] font-bold uppercase tracking-[0.22em] text-gold sm:text-[11px]" data-id="element-42" data-mp="1613q4k0mtoap">
          One Last Chance
        </p>
        <h2 id="final-title" className="mt-3 font-display text-[28px] font-bold uppercase leading-[1] tracking-tight text-cream sm:text-[42px]" data-id="element-43" data-mp="1ylanzg22sw8t">
          Your clients deserve the best version of you —{' '}
          <span className="text-gold" data-id="element-44" data-mp="sox7q5p8vwv9">not an exhausted one.</span>
        </h2>

        <p className="mx-auto mt-3 max-w-xl text-[13.5px] leading-snug text-mutedtext sm:text-[15px]" data-id="element-45" data-mp="dzix6u9xn9ea">
          Stop spending your time rebuilding sessions from scratch. Bring
          structure, progression and professional systems into your coaching
          with Functional Coach System™.
        </p>

        <div className="mx-auto mt-6 max-w-sm rounded-xl border border-gold/30 bg-panel p-4 shadow-premium sm:p-5" data-id="element-46" data-mp="906b4bqvy6cr">
          <p className="font-display text-[17px] font-bold uppercase tracking-[0.05em] text-cream sm:text-xl" data-id="element-47" data-mp="3r6kqmf4syod9">
            Functional Coach System™
          </p>
          <p className="mt-0.5 text-[12px] font-medium text-mutedtext sm:text-[13px]" data-id="element-48" data-mp="1kvaocst5fo">
            6 Professional Modules + 5 Professional Bonuses
          </p>
          <div className="hairline-gold mx-auto my-3.5 h-px w-20" aria-hidden="true" data-id="element-49" data-mp="1ucg5fv3msskk" />
          <p className="text-[10px] font-semibold uppercase tracking-[0.18em] text-mutedtext sm:text-[11px]" data-id="element-50" data-mp="1sxn4ujafeoa7">
            Reference Value:{' '}
            <span className="line-through decoration-gold/70 decoration-2" data-id="element-51" data-mp="1nzlk7txcqgwm">
              $97 USD
            </span>
          </p>
          <p className="mt-1.5 text-[10px] font-bold uppercase tracking-[0.22em] text-gold sm:text-[11px]" data-id="element-52" data-mp="1dzl2udj1mav2">
            Today
          </p>
          <p className="font-display text-[72px] font-bold leading-[0.82] tracking-tight text-cream sm:text-[84px]" data-id="element-53" data-mp="2bmk0orlh1ouj">
            $27
            <span className="ml-1.5 align-top font-display text-base font-semibold tracking-[0.12em] text-mutedtext sm:text-lg" data-id="element-54" data-mp="26qctkvhca7b0">
              USD
            </span>
          </p>
          <div className="mt-4" data-id="element-55" data-mp="1wxxbly61liq4">
            <CtaButton href={PRICING_ANCHOR} data-id="element-56" data-mp="2udb5rgyfet34">
              🚀 Yes, I Want My Functional Coach System™
            </CtaButton>
          </div>
          <p className="mt-2.5 text-[10px] font-medium uppercase tracking-[0.12em] text-mutedtext sm:text-[11px]" data-id="element-57" data-mp="2pm2wckx3j7py">
            {TRUST_LINE}
          </p>
        </div>
      </div>
    </section>;
}